import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'utcDate',
})
export class utcDatePipe extends DatePipe implements PipeTransform {
  transform(value: null | undefined, args?: string): null;
  transform(value: string | number | Date | null | undefined, args: string): string | null;
  // Needed for override
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(value: any, args?: string): string | null {
    let newValue: string = value;
    if (!newValue.endsWith('Z')) {
      newValue = newValue + 'Z';
    }
    if (!isDutchDaylightSavingTime(newValue)) {
      return super.transform(newValue, args, '+0100', 'nl-NL');
    }
    return super.transform(newValue, args, '+0200', 'nl-NL');
  }
}

const isDutchDaylightSavingTime = (date: string): boolean => {
  const utcDate = new Date(date);
  const currentYear = utcDate.getUTCFullYear();

  const daylightSavingTimeStart = new Date(Date.UTC(currentYear, 2, 31 - (((5 * currentYear) / 4 + 4) % 7), 1));
  const daylightSavingTimeEnd = new Date(Date.UTC(currentYear, 9, 31 - (((5 * currentYear) / 4 + 1) % 7), 1));

  return utcDate >= daylightSavingTimeStart && utcDate < daylightSavingTimeEnd;
};
